import { render, staticRenderFns } from "./DocumentDetailList13.vue?vue&type=template&id=37c9ee5a&scoped=true"
import script from "./DocumentDetailList13.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList13.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c9ee5a",
  null
  
)

export default component.exports